import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

function Pagination({
  totalPages,
  setPageNumber,
  pageNumber,
  numberOfButtons,
  setPageSize
}) {
  const [firstButtonRef, setFirstButonRef] = useState(1);

  const [numberedButtons, setNumberedButtons] = useState(() => {
    let _numberedButtons = [];
    let buttons = numberOfButtons || 3;
    for (let index = 1; index <= buttons; index++) {
      _numberedButtons.push(index);
    }
    return _numberedButtons;
  });

  useEffect(() => {
    //  nextPage(pageNumber);
  }, []);

  function nextPage(page) {
    let lastIndex = 0;
    if (numberedButtons.length > totalPages) {
      lastIndex = totalPages;
    } else {
      lastIndex = numberedButtons.length - 1;
    }

    if (page > numberedButtons[lastIndex]) {
      let _numberedButtons = [...numberedButtons];
      let _page = page;
      for (let index = lastIndex; index > -1; index--) {
        _numberedButtons[index] = _page;
        _page--;
      }
      setNumberedButtons(_numberedButtons);
    }
    setPageNumber(page);
  }

  function previousPage(page) {
    let _numberedButtons = [...numberedButtons];
    let increment = page;

    if (page < numberedButtons[0]) {
      for (let index = 0; index < numberedButtons.length; index++) {
        if (index <= totalPages) {
          _numberedButtons[index] = increment;
          increment++;
        }
      }
      setNumberedButtons(_numberedButtons);
    }
    setPageNumber(page);
  }

  function changePage(page) {
    if (page > totalPages) return;
    else if (page < 1) return;
    else if (page > firstButtonRef) setFirstButonRef(page);
    else if (page < firstButtonRef) setFirstButonRef(page);
    else if (page === totalPages) setFirstButonRef(page);

    setPageNumber(page);
  }

  function isActive(labelNumber) {
    if (labelNumber === pageNumber) return "active";
  }

  function isEnabledCondition(labelNumber) {
    if (labelNumber > totalPages) return "disabled";
    else if (labelNumber < 1) return "disabled";
  }

  function isEnabledLastPage(labelNumber) {
    if (labelNumber > totalPages) return "disabled";
    else if (labelNumber < 1) return "disabled";
  }

  function goToLastPage() {
    let total = totalPages;
    let _numberedButtons = [...numberedButtons];
    for (let index = numberedButtons.length - 1; index > -1; index--) {
      if (index < totalPages) {
        _numberedButtons[index] = total;
        total--;
      }
    }
    setNumberedButtons(_numberedButtons);
    setPageNumber(totalPages);
  }

  function goToFirstPage() {
    let _numberedButtons = [...numberedButtons];
    let increment = 1;
    for (let index = 0; index < numberedButtons.length; index++) {
      if (index < totalPages) {
        _numberedButtons[index] = increment;
        increment++;
      }
    }
    setNumberedButtons(_numberedButtons);
    setPageNumber(1);
  }
  function onChangePageSize({ target }) {
    setPageSize(target.value);
    goToFirstPage();
  }
  return (
    <>
      {totalPages > 0 && (
        <nav>
          <ul className="pagination justify-content-center">
            <li className={`page-item  ${isEnabledCondition(pageNumber - 1)}`}>
              <button className="page-link" onClick={goToFirstPage}>
                {"|<<"}
              </button>
            </li>

            <li className={`page-item  ${isEnabledCondition(pageNumber - 1)}`}>
              <button
                className="page-link"
                onClick={() => previousPage(pageNumber - 1)}
              >
                {"<"}
              </button>
            </li>
            {numberedButtons.map(
              (buttonRef) =>
                totalPages >= buttonRef && (
                  <li className={`page-item ${isActive(buttonRef)}`}>
                    <button
                      className="page-link"
                      onClick={() => changePage(buttonRef)}
                    >
                      {buttonRef}
                    </button>
                  </li>
                )
            )}
            <li className={`page-item  ${isEnabledCondition(pageNumber + 1)}`}>
              <button
                className="page-link"
                onClick={() => nextPage(pageNumber + 1)}
              >
                {">"}
              </button>
            </li>

            <li className={`page-item  ${isEnabledLastPage(pageNumber + 1)}`}>
              <button className="page-link" onClick={goToLastPage}>
                {">>|"}
              </button>
            </li>
            {setPageSize && (
              <li>
                <select
                  className="page-link"
                  style={{ height: "100%" }}
                  onChange={onChangePageSize}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
              </li>
            )}
          </ul>
        </nav>
      )}
    </>
  );
}
Pagination.PropType = {
  pageNumber: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  setPageNumber: PropTypes.number.isRequired,
  numberOfButtons: PropTypes.number
};

export default Pagination;
